import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import ActionDropdownItem from "../../components/Common/PageTitle/ActionDropdownItem";
import ActivityLoader from "../../components/Common/ActivityLoader";
import functions from "../../util/functions";
import { useTheme } from "../../DataStore/ThemeContext";
import AlertChangeStatus from "../../components/Student/AlertChangeStatus";
import Notification from "../../components/Common/Notification";
import AlertDeleteFile from "../../components/Student/AlertDeleteFile";
import { useStaff } from "../../DataStore/StaffContext";
import ajaxStaff from "../../util/remote/ajaxStaff";
import StaffProfileInfo from "../../components/Staff/StaffProfileInfo";
import SubjectSection from "../../components/Staff/SubjectSection";
import AlertRemoveLoad from "../../components/Staff/AlertRemoveLoad";

const StaffProfilePage = () => {
  const {
    profileInfo,
    staffId,
    loadProfile,

  } = useStaff();
  const navigate = useNavigate();
  const [showActivation, setShowActivation] = useState(false);
  const { setNotify, openSettings } = useTheme();
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [showRemoveLoad, setShowRemoveLoad] = useState(false); 


  useEffect(() => {
    if (!staffId) {
      navigate("/");
    }
  }, [staffId]);

  const handleChangeStatus = async() => {
    const newStatus = profileInfo?.status * 1 === 1 ? 0 : 1;
    const server_response = await ajaxStaff.changeStaffStatus({
      student_id: staffId,
      status: newStatus,
    });
    if(server_response.status === "OK"){
        setNotify(<Notification type='success' message={server_response.message}/>)
        loadProfile(staffId);
    }
    else {
        setNotify(<Notification type='danger' message={server_response.message}/>)
    }
    setShowActivation(false);
  }

  const handleChangePhoto = () => {
    openSettings("Change Staff Photo", "NewStaffPhoto", staffId);
  }


  const handleAssignSubject = () => {
    openSettings("Assign Subject", "AssignStaffSubject", staffId);
  }

  const handleRemoveLoad = async () => {
    if (!selectedLoad) {
      setNotify(<Notification type="danger" message="Please select a load to remove." />);
      return;
    }
    setShowRemoveLoad(true);
  }

  const handleStaffAccess = () => {
    openSettings("Access Settings", "StaffAccessConfig", staffId);
  }

  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-bullseye text-primary" label={`${profileInfo?.status*1 === 1 ? 'Deactivate' : 'Activate'} Staff`} onClick={()=>setShowActivation(true)}/>
      <ActionDropdownItem iconClass="fa fa-image text-success" label="Change Photo"onClick={handleChangePhoto} />
      <ActionDropdownItem iconClass="fa fa-plus-circle text-success" label="Add Teaching Load" onClick={handleAssignSubject} />
      {selectedLoad && <ActionDropdownItem iconClass="fa fa-minus-circle text-danger" label="Remove Load" onClick={handleRemoveLoad}/>}
      <ActionDropdownItem iconClass="fa fa-refresh text-success" label="Refresh" onClick={()=>loadProfile(staffId)} />
      <ActionDropdownItem iconClass="fa fa-user-lock text-danger" label="Access Settings" onClick={handleStaffAccess} />
      <ActionDropdownItem iconClass="fa fa-trash-alt text-danger" label="Delete Staff" />
    </>
  );

  return (
    <>
      <PageContainer>
        <MainContent>
          <PageTitle
            title="Staff Profile"
            description="View and manage staff profile details"
            iconClass="fa fa-user-tie"
            PageActions={PageActions}
            sticky={true}
          />
          <div className="row small-gutters">
            <div className="col-lg-4">
              <div className="card shadow-sm mb-4">
                <div className="card-body text-center">
                  {functions.isObject(profileInfo) && <StaffProfileInfo profileInfo={profileInfo} />}
                  {!profileInfo && <ActivityLoader />}
                </div>
              </div>
             
            </div>

            <div className="col-md-8">
              <SubjectSection onSelect = {setSelectedLoad}/>
            </div>
          </div>
          {!profileInfo && <ActivityLoader />}
        </MainContent>
      </PageContainer>
      {showActivation && <AlertChangeStatus
        show={showActivation}
        handleClose={() => setShowActivation(false)}
        title="Change Student Status"
        description={`Are you sure you want to ${profileInfo.status * 1 === 1 ? 'deactivate' : 'activate'} this student?`}
        onConfirm={handleChangeStatus}
      />}
      <AlertDeleteFile />
      {selectedLoad && <AlertRemoveLoad show={showRemoveLoad} handleClose={() => setShowRemoveLoad(false)} load={selectedLoad} callback={()=>setSelectedLoad(false)}/>}
    </>
  );
};

export default StaffProfilePage;
